const introI18n = {
  "fr": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Sélectionnez",
          "s2": " vos écrans et pièces ",
          "b2": "détachées",
          "s3": " directement depuis notre ",
          "b3": "catalogue",
          "s4": "."
        },
        "l2": {
          "s1": "En quelques clics, ",
          "b1": "choisissez",
          "s2": " les modèles que vous souhaitez ",
          "b2": "revendre",
          "s3": ", ajoutez-les à votre panier et ",
          "b3": "laissez-vous guider",
          "s4": "."
        },
        "l3": {
          "s1": "Un processus ",
          "b1": "simple",
          "s2": ", ",
          "b2": "rapide",
          "s3": " et totalement transparent, de la ",
          "b3": "sélection",
          "s4": " à l’envoi, jusqu’au ",
          "b4": "paiement",
          "s5": " en seulement ",
          "b5": "5 étapes",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Paiement garanti",
          "body": "Encaissez immédiatement après validation de vos pièces, sans aucun délai supplémentaire."
        },
        "c2": {
          "title": "Processus en 5 étapes",
          "body": "Simple, rapide et accessible à tous, du tri à l’encaissement en toute transparence."
        },
        "c3": {
          "title": "Valeur maximale",
          "body": "Vos écrans et pièces sont rachetés au meilleur prix du marché, avec fiabilité garantie."
        }
      },
      "outro": {
        "b1": "Ne laissez plus dormir vos écrans et pièces inutilisées.",
        "s1": " Transformez-les en ",
        "b2": "cash",
        "s2": " dès aujourd’hui !"
      }
    }
  },
  "en": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Select",
          "s2": " your screens and ",
          "b2": "spare parts",
          "s3": " directly from our ",
          "b3": "catalog",
          "s4": "."
        },
        "l2": {
          "s1": "In just a few clicks, ",
          "b1": "choose",
          "s2": " the models you want to ",
          "b2": "sell",
          "s3": ", add them to your cart and ",
          "b3": "let us guide you",
          "s4": "."
        },
        "l3": {
          "s1": "A ",
          "b1": "simple",
          "s2": ", ",
          "b2": "fast",
          "s3": " and fully transparent process, from ",
          "b3": "selection",
          "s4": " to shipping, through to ",
          "b4": "payment",
          "s5": " in just ",
          "b5": "5 steps",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Guaranteed payment",
          "body": "Get paid immediately after your parts are validated, with no extra delay."
        },
        "c2": {
          "title": "5-step process",
          "body": "Simple, fast and accessible to everyone, from sorting to payout with full transparency."
        },
        "c3": {
          "title": "Maximum value",
          "body": "Your screens and parts are bought at the best market price with guaranteed reliability."
        }
      },
      "outro": {
        "b1": "Stop letting unused screens and parts gather dust.",
        "s1": " Turn them into ",
        "b2": "cash",
        "s2": " today!"
      }
    }
  },
  "pl": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Wybierz",
          "s2": " swoje ekrany i ",
          "b2": "części zamienne",
          "s3": " bezpośrednio z naszego ",
          "b3": "katalogu",
          "s4": "."
        },
        "l2": {
          "s1": "W kilka kliknięć ",
          "b1": "wybierz",
          "s2": " modele, które chcesz ",
          "b2": "sprzedać",
          "s3": ", dodaj je do koszyka i ",
          "b3": "daj się poprowadzić",
          "s4": "."
        },
        "l3": {
          "s1": "Proces ",
          "b1": "prosty",
          "s2": ", ",
          "b2": "szybki",
          "s3": " i całkowicie przejrzysty, od ",
          "b3": "wyboru",
          "s4": " po wysyłkę, aż do ",
          "b4": "płatności",
          "s5": " w zaledwie ",
          "b5": "5 krokach",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Gwarantowana płatność",
          "body": "Otrzymasz płatność natychmiast po weryfikacji części — bez dodatkowych opóźnień."
        },
        "c2": {
          "title": "Proces w 5 krokach",
          "body": "Prosty, szybki i dostępny dla każdego — od selekcji po wypłatę, w pełnej przejrzystości."
        },
        "c3": {
          "title": "Maksymalna wartość",
          "body": "Twoje ekrany i części odkupywane są w najlepszej cenie rynkowej, z gwarancją rzetelności."
        }
      },
      "outro": {
        "b1": "Nie pozwól, aby nieużywane ekrany i części się marnowały.",
        "s1": " Zamień je w ",
        "b2": "gotówkę",
        "s2": " już dziś!"
      }
    }
  },
  "es": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Selecciona",
          "s2": " tus pantallas y ",
          "b2": "piezas",
          "s3": " directamente desde nuestro ",
          "b3": "catálogo",
          "s4": "."
        },
        "l2": {
          "s1": "En unos pocos clics, ",
          "b1": "elige",
          "s2": " los modelos que deseas ",
          "b2": "vender",
          "s3": ", añádelos a tu carrito y ",
          "b3": "déjate guiar",
          "s4": "."
        },
        "l3": {
          "s1": "Un proceso ",
          "b1": "simple",
          "s2": ", ",
          "b2": "rápido",
          "s3": " y totalmente transparente, desde la ",
          "b3": "selección",
          "s4": " hasta el envío, pasando por el ",
          "b4": "pago",
          "s5": " en solo ",
          "b5": "5 pasos",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Pago garantizado",
          "body": "Cobra inmediatamente después de la validación de tus piezas, sin ningún retraso adicional."
        },
        "c2": {
          "title": "Proceso en 5 pasos",
          "body": "Simple, rápido y accesible para todos, desde la clasificación hasta el cobro con total transparencia."
        },
        "c3": {
          "title": "Valor máximo",
          "body": "Tus pantallas y piezas se recompran al mejor precio del mercado, con fiabilidad garantizada."
        }
      },
      "outro": {
        "b1": "No dejes que tus pantallas y piezas sin usar acumulen polvo.",
        "s1": " ¡Transfórmalas en ",
        "b2": "dinero",
        "s2": " hoy mismo!"
      }
    }
  },
  "it": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Seleziona",
          "s2": "i tuoi schermi e",
          "b2": "pezzi di ricambio",
          "s3": "direttamente dal nostro",
          "b3": "catalogo",
          "s4": "."
        },
        "l2": {
          "s1": "In pochi clic,",
          "b1": "scegliere",
          "s2": "i modelli che si desidera",
          "b2": "vendita",
          "s3": ", aggiungerli al carrello e",
          "b3": "Lascia che ti accompagni",
          "s4": "."
        },
        "l3": {
          "s1": "A",
          "b1": "semplice",
          "s2": ", ",
          "b2": "veloce",
          "s3": "e processo completamente trasparente, da",
          "b3": "selezione",
          "s4": "alla spedizione, fino a",
          "b4": "pagamento",
          "s5": "nel solo",
          "b5": "5 passi",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Pagamento garantito",
          "body": "Ricevi immediatamente pagato dopo la convalida delle tue parti, senza alcun ritardo aggiuntivo."
        },
        "c2": {
          "title": "Processo a 5 fasi",
          "body": "Semplice, veloce e accessibile a tutti, dalla selezione alla vincita con piena trasparenza."
        },
        "c3": {
          "title": "Valore massimo",
          "body": "I vostri schermi e parti sono acquistati al miglior prezzo di mercato con affidabilità garantita."
        }
      },
      "outro": {
        "b1": "Smettere di lasciare schermi e parti inutilizzate raccogliere polvere.",
        "s1": "Trasformali in",
        "b2": "contanti",
        "s2": "Oggi!"
      }
    }
  },
  "de": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Wählen",
          "s2": "Ihre Bildschirme und",
          "b2": "Ersatzteile",
          "s3": "direkt von unserem",
          "b3": "Katalog",
          "s4": "."
        },
        "l2": {
          "s1": "In nur wenigen Klicks,",
          "b1": "wählen",
          "s2": "Die Modelle, die Sie wollen",
          "b2": "Verkauf",
          "s3": "fügen Sie sie Ihrem Warenkorb hinzu und",
          "b3": "Lassen Sie uns Sie leiten",
          "s4": "."
        },
        "l3": {
          "s1": "A",
          "b1": "einfach",
          "s2": ", ",
          "b2": "schnell",
          "s3": "vollständig transparentes Verfahren, von",
          "b3": "Auswahl",
          "s4": "zum Versand, bis zum",
          "b4": "Zahlung",
          "s5": "nur",
          "b5": "5 Stufen",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Garantierte Zahlung",
          "body": "Erhalten Sie sofort bezahlt, nachdem Ihre Teile validiert sind, ohne zusätzliche Verzögerung."
        },
        "c2": {
          "title": "5-stufiges Verfahren",
          "body": "Einfach, schnell und für jeden zugänglich, vom Sortieren bis zur Auszahlung mit voller Transparenz."
        },
        "c3": {
          "title": "Höchstwert",
          "body": "Ihre Bildschirme und Teile werden zum besten Marktpreis mit garantierter Zuverlässigkeit gekauft."
        }
      },
      "outro": {
        "b1": "Hören Sie auf, unbenutzte Bildschirme und Teile Staub sammeln zu lassen.",
        "s1": "Verwandeln Sie sich in",
        "b2": "Bargeld",
        "s2": "Heute!"
      }
    }
  },
  "pt": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Selecionar",
          "s2": "os seus ecrãs e",
          "b2": "peças sobressalentes",
          "s3": "directamente da nossa",
          "b3": "catálogo",
          "s4": "."
        },
        "l2": {
          "s1": "Em apenas alguns cliques,",
          "b1": "escolher",
          "s2": "os modelos que você deseja",
          "b2": "vender",
          "s3": ", adicioná-los ao seu carrinho e",
          "b3": "Deixe-nos guiá-lo",
          "s4": "."
        },
        "l3": {
          "s1": "A",
          "b1": "simples",
          "s2": ", ",
          "b2": "rápido",
          "s3": "e processo totalmente transparente,",
          "b3": "seleção",
          "s4": "para o transporte, através de",
          "b4": "pagamento",
          "s5": "em justo",
          "b5": "5 passos",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Pagamento garantido",
          "body": "Seja pago imediatamente após suas peças serem validadas, sem atraso extra."
        },
        "c2": {
          "title": "Processo de 5 passos",
          "body": "Simples, rápido e acessível para todos, desde a ordenação até o pagamento com total transparência."
        },
        "c3": {
          "title": "Valor máximo",
          "body": "Suas ecrãs e peças são compradas ao melhor preço de mercado com confiabilidade garantida."
        }
      },
      "outro": {
        "b1": "Pare de deixar ecrãs e peças não utilizadas juntar poeira.",
        "s1": "Transformá-los em",
        "b2": "numerário",
        "s2": "Hoje!"
      }
    }
  },
  "cs": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Vybrat",
          "s2": "Vaše obrazovky a",
          "b2": "náhradní díly",
          "s3": "přímo z našeho",
          "b3": "katalog",
          "s4": "."
        },
        "l2": {
          "s1": "Za pár kliknutí,",
          "b1": "vybrat",
          "s2": "modelky, které chcete",
          "b2": "prodat",
          "s3": ", přidejte je do košíku a",
          "b3": "Nechte nás vás vést.",
          "s4": "."
        },
        "l3": {
          "s1": "A",
          "b1": "jednoduché",
          "s2": ", ",
          "b2": "rychle",
          "s3": "a plně transparentní proces, od",
          "b3": "výběr",
          "s4": "na přepravu, přes",
          "b4": "platba",
          "s5": "v just",
          "b5": "5 kroků",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Zaručená platba",
          "body": "Dostávejte zaplaceno ihned poté, co vaše části jsou validovány, bez dalšího zpoždění."
        },
        "c2": {
          "title": "5stupňový proces",
          "body": "Jednoduché, rychlé a přístupné všem, od třídění po výplatu s plnou průhledností."
        },
        "c3": {
          "title": "Maximální hodnota",
          "body": "Vaše obrazovky a díly jsou zakoupeny za nejlepší tržní cenu se zaručenou spolehlivostí."
        }
      },
      "outro": {
        "b1": "Přestaňte nechávat nepoužité obrazovky a části sbírat prach.",
        "s1": "Proměň je v",
        "b2": "hotovost",
        "s2": "Dnes!"
      }
    }
  },
  "nl": {
    "intro": {
      "lead": {
        "l1": {
          "s1": "",
          "b1": "Selecteren",
          "s2": "uw schermen en",
          "b2": "reserveonderdelen",
          "s3": "rechtstreeks van onze",
          "b3": "catalogus",
          "s4": "."
        },
        "l2": {
          "s1": "In slechts een paar klikken,",
          "b1": "kiezen",
          "s2": "de modellen die u wilt",
          "b2": "verkopen",
          "s3": ", voeg ze toe aan uw winkelwagen en",
          "b3": "laat ons u begeleiden",
          "s4": "."
        },
        "l3": {
          "s1": "A",
          "b1": "eenvoudig",
          "s2": ", ",
          "b2": "snel",
          "s3": "en volledig transparant proces, van",
          "b3": "selectie",
          "s4": "naar de scheepvaart, door naar",
          "b4": "betaling",
          "s5": "in",
          "b5": "5 stappen",
          "s6": "."
        }
      },
      "cards": {
        "c1": {
          "title": "Gegarandeerde betaling",
          "body": "Ontvang betaald onmiddellijk nadat uw onderdelen zijn gevalideerd, zonder extra vertraging."
        },
        "c2": {
          "title": "5 stappen",
          "body": "Eenvoudig, snel en toegankelijk voor iedereen, van sorteren tot uitbetaling met volledige transparantie."
        },
        "c3": {
          "title": "Maximumwaarde",
          "body": "Uw schermen en onderdelen worden gekocht tegen de beste marktprijs met gegarandeerde betrouwbaarheid."
        }
      },
      "outro": {
        "b1": "Laat geen ongebruikte schermen en onderdelen stof verzamelen.",
        "s1": "Verander ze in",
        "b2": "contant",
        "s2": "vandaag!"
      }
    }
  }
};

export default introI18n;
